document.addEventListener('DOMContentLoaded', () => {
  
    
    function translatePackagingFeeText() {
        let cartFooter = document.querySelector('.cart-drawer__footer');
        if (cartFooter) {
            // Interval to look for .mw-stack every 0.2s, max 4s
            let intervalCount = 0;
            const maxIntervals = 20; // 0.2s * 20 = 4s
            const intervalId = setInterval(() => {
            intervalCount++;
            const items = document.querySelectorAll('.mw-stack__item');
            let found = false;
            let foundGave = false;
            let foundGaveTitle = false;
            items.forEach(item => {
                if (item.textContent.trim() === 'Emballagegebyr - (Kan ikke refunderes)') {
                found = true;
                item.textContent = 'Förpackningsavgift - (Ej återbetalningsbar)';
                }
                let text = item.querySelector('.mw-fee__control-title .mw-text');
                if (text && text.textContent.includes('Gaveindpakning -')) {
                    foundGave = true;
                    // Replace only the 'Gaveindpakning -' part, keep the money span
                    text.innerHTML = text.innerHTML.replace('Gaveindpakning -', 'Presentinslagning -');
                }
                let titleText = item.querySelector('.mw-text.mw-text--style-strong');
                if (titleText && titleText.textContent.trim() === 'Gaveindpakning') {
                    foundGaveTitle = true;
                    titleText.textContent = 'Presentinslagning';
                }
            });
            if (found && foundGave && foundGaveTitle) {
                clearInterval(intervalId);
            } else if (intervalCount >= maxIntervals) {
                console.log('Stopped looking for .mw-stack__item after 4s');
                clearInterval(intervalId);
            } else {
                console.log('Looking for .mw-stack__item with specific text...');
            }
            }, 200);
        }
    }
    let swedish = document.body.classList.contains('swedish-body');
    if (swedish) {
        translatePackagingFeeText();

        // Example: after changing the cart, update the packaging fee text
        const originalFetch = window.fetch;
        window.fetch = function(input, init) {
            // Check if the URL matches /cart/add.js
            let url = typeof input === 'string' ? input : input.url;
            if (url && url.includes('/cart/add.js')) {
                // After the fetch completes, run your function
                return originalFetch(input, init).then(response => {
                    // Optionally, check response status or data here
                    setTimeout(translatePackagingFeeText, 500);
                    console.log('Intercepted /cart/add.js fetch, ran translation.');
                    return response;
                });
            }
            // For all other fetches, just run normally
            return originalFetch(input, init);
        };
    }

});